const NotAllowedCharsRegex = /[^A-ZÀÄÆÇČÊËÎÏÈÉÌÔÒÖŒÛÜŠŽẞÙ0-9]/g;

/**
 * Rimuove i caratteri speciali non ammessi dal codice fiscale.
 */
export function normalizeSpecialChars(value: string) {
  const allowed = value.toUpperCase().replace(NotAllowedCharsRegex, '');
  return allowed.replace(/[ÀÄÆÇČÊËÎÏÈÉÌÔÒÖŒÛÜŠŽẞÙ]/g, char =>
    char in specialCharsMap
      ? specialCharsMap[char as keyof typeof specialCharsMap]
      : char,
  );
}

// Fonte: https://dait.interno.gov.it/documenti/circolare-n-1-2008-0.pdf
const specialCharsMap = {
  À: 'A',
  Ä: 'A',
  Æ: 'AE',
  Ç: 'C',
  Č: 'C',
  Ê: 'E',
  Ë: 'E',
  Î: 'I',
  Ï: 'I',
  È: 'E',
  É: 'E',
  Ì: 'I',
  Ô: 'O',
  Ò: 'O',
  Ö: 'O',
  Œ: 'OE',
  // U circonflessa
  Û: 'U',
  // U con dieresi
  Ü: 'U',
  // S caron
  Š: 'S',
  // Z caron
  Ž: 'Z',
  // doppia S
  ẞ: 'SS',
  Ù: 'U',
};
